import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import {
  MaterialModule,
  MdNativeDateModule,
  MdAutocompleteModule,
  MdTableModule,
  MdDatepickerModule,
  MdSnackBarModule
} from '@angular/material';
import { CdkTableModule } from '@angular/cdk/table';
import { NavigationModule } from './navigation/navigation.module';
import { CalendarModule } from 'angular-calendar';
import { StarRatingModule } from 'angular-star-rating';
import { ChartsModule } from 'ng2-charts';
import { NKDatetimeModule } from 'ng2-datetime/ng2-datetime';

import { AppComponent } from './app.component';

import { MdInputModule } from '@angular/material';

import { ObserversModule } from '@angular/cdk/observers';

import {
  AgendaComponent,
  ConsignaDetailComponent,
  NewConsignaDialogComponent,
  RepetirSubDialogComponent,
  LoginComponent,
  CuentasComponent,
  ActividadComponent,
  ConfiguracionComponent,
  DashboardComponent,
  NegociosHeaderComponent,
  NegociosComponent,
  PrecioEspecialDialogComponent,
  NewNegocioDialogComponent,
  NegocioDetailComponent,
  FiltersNegociosDialogComponent,
  PreciosComponent,
  PrecioDialogComponent,
  FiltersPreciosDialogComponent,
  NewPrecioComponent,
  EntregaDialogComponent,
  RateComponent,
  TextDialogComponent,
  TextAreaDialogComponent,
  ContactoDetailComponent,
  CuentaDetailComponent,
  NewContactoDialogComponent,
  ColaboradorDetailComponent,
  NewColaboradorDialogComponent,
  ActivityListComponent,
  ActividadFilterComponent,
  BuscadorComponent,
  BuscadorColaboradoresFilterComponent,
  BuscadorCuentasFilterComponent,
  BuscadorConsignasFilterComponent,
  CircleProgressComponent,
  SpinnerComponent,
  ColaboradorAutocompleteComponent,
  CuentaAutocompleteComponent,
  CuentaEtiquetaAutocompleteComponent,
  MotorAutocompleteComponent,
  ABMComponent,
  RolDetailComponent,
  AcopioDetailComponent,
  CategoriaDetailComponent,
  ABMRolesFilterComponent,
  ABMCategoriasFilterComponent,
  ABMAcopiosFilterComponent,
  EtiquetaAutocompleteComponent,
  CategoriaAutocompleteComponent,
  AcopioAutocompleteComponent,
  RolesAutocompleteComponent,
  NewCuentaDialogComponent,
  NotificationSnackbarComponent,
  FileUploadComponent,
  UserAvatar,
  MultipleUserAvatar,
  Metrica,
  PrecioMetrica,
  NewEtiquetaComponent,
  NewAcopioDialogComponent,
  NewCategoriaDialogComponent,
  ColaboradoresDialogComponent,
  ContactosDialogComponent,
  EmpresasDialogComponent,
  PerfilComponent,
  NewEditProductoDialogComponent,
  EntregasOcultasDialogComponent,
  ComunicacionesComponent,
  ComunicacionDetailComponent,
  NewComunicacionDialogComponent,
  FileUploadComunicacionComponent,
  TableroNegociosComponent,
  ExpandedChartDialogComponent,
  ValidatePrecioComponent,
  NumberEditDialogComponent,
  ChipsSelectorComponent,
  NewPrecioPizarraComponent,
  ClienteSaldoListComponent,
  HistoryListComponent,
  ColaboradoresListComponent,
  PreciosPizarraComponent,
  NegociosKanbanComponent,
  NegocioKanbanCardComponent,
  NegociosKanbanFiltersComponent,
  MdSelectFilterComponent,
  PermisosListComponent,
  PermisosDetailComponent,
  ActionComponent,
  PriceResizeComponent,
  MercadoComponent,
  NewEditMercadoDialogComponent,
  DropdownDialogComponent,
  FinancieraComponent,
  NewPrecioFinancieraComponent,
  ValidatePrecioFinancieraComponent,
  EntidadesFinancierasComponent,
  NewEntidadDialogComponent,
  AdministracionHeaderComponent,
  DolarizacionComponent,
  GenericFilterDialogComponent,
  PrecioDolarDetailDialogComponent,
  PrecioMonitorComponent,
  UsuariosComponent,
  GenericTableDialogComponent,
  EditUsuarioComponent,
  UsuarioAgroDetailComponent,
  UsuarioAgroHistorialComponent,
  ChipFilterListComponent,
  UsuarioAgroPendientesComponent,
  AcoCuitDialogComponent,
  PageHeaderComponent,
  AcordeonContainerComponent,
  AcordeonItemComponent,
  AgrisHomePageComponent,
  AgrisBuscadorPageComponent,
  AgrisBarraBusquedaComponent,
  AgrisDetalleInsumoPageComponent,
  AgregarInsumoDialogComponent,
  AgrisNuevaCotizacionPageComponent,
  AgrisClienteCotizacionCardComponent,
  AgrisCantidadSelectorComponent,
  AgrisCotizacionDetallePageComponent,
  AgrisInsertInsumCotizDialogComponent,
  AgrisEditPriceInsCotizDialogComponent,
  AgrisCotizDetalleGuardarDialogComponent,
  AgrisCotizDetallePnjdeDialogComponent,
  AgrisCotizDetalleRenovarDialogComponent,
  AgrisListaCotizacionesPageComponent,
  AgregarInsACotizExistenteDialogComponent,
  AgrisSelectorOficSucComponent,
  SelectorOficSucDialogComponent,
  AgrisAccesoRestringidoDialogComponent,
  AgrisCorizPerderDialogComponent,
  AgrisConfirmDialogComponent,
  AgrisActivityPipe,
  NegociosFuenteIconComponent,
  PreciosHeaderComponent,
  PreciosAgdComponent,
  SideMenuListItemComponent,
  SideMenuScrollerComponent,
  PreciosToImgDialogComponent,
  EditAcopioDialogComponent,
  NegocioListComponent,
  NegNewFiltersDialogComponent,
  NewNegocioResponsiveDialogComponent,
} from './components';

import {
  NavigationService,
  ColaboradoresService,
  AuthenticationService,
  AgendaService,
  CuentasService,
  HttpClient,
  GoogleMapsService,
  ActividadService,
  SearchService,
  DashboardService,
  DialogsService,
  ABMRolesService,
  FirebaseMessagingService,
  ConfiguracionService,
  UserAvatarService,
  NegociosService,
  CosechaService,
  MonedaService,
  PosicionService,
  ProductoService,
  CommonService,
  PreciosService,
  EntregaService,
  SpinnerService,
  ComunicacionService,
  TableroNegocioService,
  ExcelExporterService,
  CategoriaService,
  SortService,
  FileSaverService,
  HistoryService,
  PermisosService,
  AgrisService,
  FinancieraService,
  DolarizacionService,
  RemitosService,
  ProvinciasService,
  ResultsCacheService,
  ResponsiveService,
  BreakpointsObserverService,
  ActivityService,
  NegocioDataService,
} from './services';

import {
  TruncatePipe,
  DateTimePipe,
  ToDatePipe,
  CapitalizePipe,
  TimeFromNow,
  WeekNumberPipe,
  NotificationTimePipe,
  CuitPipe,
  PricePipe,
  CurrencyPipe,
  TnsPipe,
  EmailValidatorDirective,
  PhoneValidatorDirective,
  PriorityPipe,
  KeysPipe,
  ClickOutsideDirective,
  InputNumberDirective,
  HorizontalScrollwheelDirective,
  StickyItemDirective,
  InputManagerDirective,
  ClickActionsDirective,
} from './utils';

import 'hammerjs';
import * as $ from 'jquery';
import { SignalrService } from './signalr/signalR.service';
import * as FormComponents from './components/common/form-components';
import * as Remitos from './components/administracion/remitos';
import { CreditNotConfiguredDialogComponent } from './components/creditos/credit-not-configured-dialog/credit-not-configured-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    AgendaComponent,
    LoginComponent,
    CuentasComponent,
    ActividadComponent,
    ConfiguracionComponent,
    DashboardComponent,
    NegociosHeaderComponent,
    NegociosComponent,
    PrecioEspecialDialogComponent,
    NegocioDetailComponent,
    FiltersNegociosDialogComponent,
    PreciosComponent,
    PrecioDialogComponent,
    FiltersPreciosDialogComponent,
    NewPrecioComponent,
    EntregaDialogComponent,
    TruncatePipe,
    RateComponent,
    TextDialogComponent,
    ConsignaDetailComponent,
    DateTimePipe,
    ToDatePipe,
    TextAreaDialogComponent,
    NewNegocioDialogComponent,
    NewConsignaDialogComponent,
    RepetirSubDialogComponent,
    ContactoDetailComponent,
    CuentaDetailComponent,
    NewContactoDialogComponent,
    ColaboradorDetailComponent,
    NewColaboradorDialogComponent,
    CapitalizePipe,
    ActivityListComponent,
    ActividadFilterComponent,
    BuscadorComponent,
    BuscadorColaboradoresFilterComponent,
    BuscadorCuentasFilterComponent,
    BuscadorConsignasFilterComponent,
    CircleProgressComponent,
    SpinnerComponent,
    ColaboradorAutocompleteComponent,
    CuentaAutocompleteComponent,
    CuentaEtiquetaAutocompleteComponent,
    MotorAutocompleteComponent,
    ABMComponent,
    RolDetailComponent,
    AcopioDetailComponent,
    CategoriaDetailComponent,
    ABMRolesFilterComponent,
    ABMCategoriasFilterComponent,
    ABMAcopiosFilterComponent,
    EtiquetaAutocompleteComponent,
    CategoriaAutocompleteComponent,
    AcopioAutocompleteComponent,
    RolesAutocompleteComponent,
    TimeFromNow,
    NewCuentaDialogComponent,
    NotificationSnackbarComponent,
    WeekNumberPipe,
    NotificationTimePipe,
    CuitPipe,
    PricePipe,
    CurrencyPipe,
    TnsPipe,
    EmailValidatorDirective,
    PhoneValidatorDirective,
    FileUploadComponent,
    UserAvatar,
    MultipleUserAvatar,
    Metrica,
    PrecioMetrica,
    NewEtiquetaComponent,
    NewAcopioDialogComponent,
    NewCategoriaDialogComponent,
    ColaboradoresDialogComponent,
    ContactosDialogComponent,
    EmpresasDialogComponent,
    PerfilComponent,
    NewEditProductoDialogComponent,
    EntregasOcultasDialogComponent,
    ComunicacionesComponent,
    PriorityPipe,
    ComunicacionDetailComponent,
    NewComunicacionDialogComponent,
    FileUploadComunicacionComponent,
    TableroNegociosComponent,
    ExpandedChartDialogComponent,
    ValidatePrecioComponent,
    NumberEditDialogComponent,
    ChipsSelectorComponent,
    NewPrecioPizarraComponent,
    ClienteSaldoListComponent,
    KeysPipe,
    HistoryListComponent,
    ColaboradoresListComponent,
    PreciosPizarraComponent,
    NegociosKanbanComponent,
    NegocioKanbanCardComponent,
    NegociosKanbanFiltersComponent,
    ClickOutsideDirective,
    MdSelectFilterComponent,
    PermisosListComponent,
    PermisosDetailComponent,
    ActionComponent,
    PriceResizeComponent,
    InputNumberDirective,
    HorizontalScrollwheelDirective,
    MercadoComponent,
    NewEditMercadoDialogComponent,
	DropdownDialogComponent,
    FinancieraComponent,
    NewPrecioFinancieraComponent,
    ValidatePrecioFinancieraComponent,
    EntidadesFinancierasComponent,
    NewEntidadDialogComponent,
    UsuariosComponent,
    GenericFilterDialogComponent,
	AdministracionHeaderComponent,
    DolarizacionComponent,
    PrecioDolarDetailDialogComponent,
    PrecioMonitorComponent,
    GenericTableDialogComponent,
    EditUsuarioComponent,
    UsuarioAgroDetailComponent,
    UsuarioAgroHistorialComponent,
    ChipFilterListComponent,
    StickyItemDirective,
    UsuarioAgroPendientesComponent,
    AcoCuitDialogComponent,
    PageHeaderComponent,
    InputManagerDirective,
    AgrisHomePageComponent,
    AgrisBuscadorPageComponent,
    AgrisBarraBusquedaComponent,
    AgrisDetalleInsumoPageComponent,
    AcordeonContainerComponent,
    AcordeonItemComponent,
    AgregarInsumoDialogComponent,
    AgrisNuevaCotizacionPageComponent,
    AgrisClienteCotizacionCardComponent,
    AgrisCantidadSelectorComponent,
    AgrisCotizacionDetallePageComponent,
    AgrisInsertInsumCotizDialogComponent,
    AgrisEditPriceInsCotizDialogComponent,
    AgrisCotizDetalleGuardarDialogComponent,
    AgrisCotizDetallePnjdeDialogComponent,
    AgrisCotizDetalleRenovarDialogComponent,
    AgrisListaCotizacionesPageComponent,
    AgregarInsACotizExistenteDialogComponent,
    AgrisSelectorOficSucComponent,
    SelectorOficSucDialogComponent,
    AgrisAccesoRestringidoDialogComponent,
    AgrisCorizPerderDialogComponent,
    AgrisConfirmDialogComponent,
    AgrisActivityPipe,
    NegociosFuenteIconComponent,
    PreciosHeaderComponent,
    PreciosAgdComponent,
    SideMenuListItemComponent,
    SideMenuScrollerComponent,
    FormComponents.FormInputComponent,
    FormComponents.FormSelectSingleComponent,
    FormComponents.FormDatepickerComponent,
    FormComponents.FormSelectMultipleComponent,
    FormComponents.FormMultipleValuePipe,
    FormComponents.FormSelectSingleIsComponent,
    Remitos.RemitosHomeComponent,
    Remitos.RemitosDetailPageComponent,
    Remitos.RemitosGenerarPageComponent,
    Remitos.RemitosCliSelectorDialogComponent,
    Remitos.RemitosFiltrosDialogComponent,
    Remitos.RemitosFechaSelectorComponent,
    Remitos.RemitosSelectorProductosDialogComponent,
    Remitos.RemitoAcopioSelectorAutocompleteDialogComponent,
    Remitos.AcopioSelectorDialogComponent,
    Remitos.RemitosMotivoDialog,
    PreciosToImgDialogComponent,
    EditAcopioDialogComponent,
    NegocioListComponent,
    ClickActionsDirective,
    NegNewFiltersDialogComponent,
    CreditNotConfiguredDialogComponent,
    NewNegocioResponsiveDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    MaterialModule,
    NavigationModule,
    CalendarModule.forRoot(),
    StarRatingModule.forRoot(),
    MdNativeDateModule,
    MdAutocompleteModule,
    MdTableModule,
    CdkTableModule,
    MdDatepickerModule,
    ChartsModule,
    MdSnackBarModule,
    NKDatetimeModule,
    ObserversModule,
  ],
  providers: [
    NavigationService,
    AuthenticationService,
    HttpClient,
    AgendaService,
    DialogsService,
    CuentasService,
    ColaboradoresService,
    GoogleMapsService,
    ActividadService,
    SearchService,
    DashboardService,
    ABMRolesService,
    FirebaseMessagingService,
    ConfiguracionService,
    UserAvatarService,
    NegociosService,
    ProductoService,
    MonedaService,
    CosechaService,
    PosicionService,
    EntregaService,
    PreciosService,
    CommonService,
    PricePipe,
    CurrencyPipe,
    DateTimePipe,
    TnsPipe,
    SignalrService,
    SpinnerService,
    ComunicacionService,
    TableroNegocioService,
    ExcelExporterService,
    CategoriaService,
    SortService,
    FileSaverService,
    HistoryService,
    PermisosService,
    AgrisService,
    FinancieraService,
    DolarizacionService,
    RemitosService,
    ProvinciasService,
    ResultsCacheService,
    ResponsiveService,
    BreakpointsObserverService,
    ActivityService,
    NegocioDataService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    RateComponent,
    TextDialogComponent,
    TextAreaDialogComponent,
    FiltersNegociosDialogComponent,
    PrecioEspecialDialogComponent,
    NewNegocioDialogComponent,
    NewConsignaDialogComponent,
    RepetirSubDialogComponent,
    NewContactoDialogComponent,
    NewColaboradorDialogComponent,
    NewCuentaDialogComponent,
    NotificationSnackbarComponent,
    NewEtiquetaComponent,
    NewAcopioDialogComponent,
    NewCategoriaDialogComponent,
    ColaboradoresDialogComponent,
    ContactosDialogComponent,
    EmpresasDialogComponent,
    PrecioDialogComponent,
    FiltersPreciosDialogComponent,
    EntregaDialogComponent,
    NewEditProductoDialogComponent,
    EntregasOcultasDialogComponent,
    NewComunicacionDialogComponent,
    ExpandedChartDialogComponent,
    NumberEditDialogComponent,
    NewEditMercadoDialogComponent,
    DropdownDialogComponent,
    NewEntidadDialogComponent,
    GenericFilterDialogComponent,
    PrecioDolarDetailDialogComponent,
    GenericTableDialogComponent,
    AcoCuitDialogComponent,
    AgregarInsumoDialogComponent,
    AgrisInsertInsumCotizDialogComponent,
    AgrisEditPriceInsCotizDialogComponent,
    AgrisCotizDetalleGuardarDialogComponent,
    AgrisCotizDetallePnjdeDialogComponent,
    AgrisCotizDetalleRenovarDialogComponent,
    AgregarInsACotizExistenteDialogComponent,
    SelectorOficSucDialogComponent,
    AgrisAccesoRestringidoDialogComponent,
    AgrisCorizPerderDialogComponent,
    AgrisConfirmDialogComponent,
    Remitos.RemitosCliSelectorDialogComponent,
    Remitos.RemitosFiltrosDialogComponent,
    Remitos.RemitosSelectorProductosDialogComponent,
    Remitos.RemitoAcopioSelectorAutocompleteDialogComponent,
    Remitos.AcopioSelectorDialogComponent,
    Remitos.RemitosMotivoDialog,
    PreciosToImgDialogComponent,
    EditAcopioDialogComponent,
    NegNewFiltersDialogComponent,
    CreditNotConfiguredDialogComponent,
    NewNegocioResponsiveDialogComponent,
  ] // Dynamically generated components
})
export class AppModule { }



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/app.module.ts